export const defaultColumnNames: { [key: string]: string } = {
  id: "ID",
  isActive: "Active",
  countOfGames: "Games",
  geoRestrictions: "GEO Restrictions",
  countOfCollections: "Collections",
  imageSmall: "Image",
  balanceBonus: "Bonus",
  balanceReal: "Real",
  countOfUsers: "Users",
  levelNumber: "Level",
  numberOfDeposit: "Deposits",
  maxUsedCount: "Use count (max)",
  currentUsedCount: "Used",
  isMobile: "Mobile",
  isDesktop: "Desktop",
  isDeactivated: "Deactivated",
  hasFreeSpins: "Free spins",
  paymentProviderImage: "Provider",
  amountAttempt: "Attempt",
  amountPaid: "Paid",
  fullName: "Name",
  riskStatus: "status",
  registeredAt: "Registered",
  verificationStatus: "Verification",
  affId: "Aff",
  affiliateId: "Affiliate ID",
  isOnline: "",
  cashBackType: "Type",
  accountId: "Account ID",
  accountName: "Account Name",
  planName: "Plan",
  zoneId: "Zone ID",
  zoneName: "Zone Name",
  isDefault: "Default",
  publicId: "Public ID",
  externalRef: "External Ref",
  statusCode: "Status",
  reasonCode: "Reason",
};
